// Motion helpers shared by the marketing pages and the router (issue #241).

export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

// Scrolls to a section and moves focus to its heading so keyboard and screen reader
// users land where the page scrolled. Instant under reduced motion.
export function scrollToSection(id: string): void {
  const section = document.getElementById(id)
  if (section === null) return
  section.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' })
  const heading = section.querySelector<HTMLElement>('h2')
  heading?.focus({ preventScroll: true })
}

// Moves focus to a section heading without scrolling (the router already handles the scroll).
// Used for #hash deep links and the /contact redirect so keyboard and screen reader users
// land on the heading. The heading needs tabindex="-1".
export function focusHeading(id: string): void {
  document.getElementById(id)?.focus({ preventScroll: true })
}
